
export default {
  settings: {
    endpointsSectionTitle: 'Service-Endpunkte (URI oder vollständige URL)',
    language: 'Sprache (Language)',
    appLocale: 'App Sprache',
    unit: 'Einheit',
    areaUnit: 'Flächeneinheit',
    saveToLocalStorage: 'Im Browser speichern',
    routeInstructions: 'Sprache der Wegbeschreibung',
    alternativeIsochroneColors: 'Alternative Isochronenfarben',
    distanceMarkers: 'Distanzmarkierungen',
    elevationProfile: 'Höhenprofil',
    mapSettings: 'Kartenansicht und extra Infos',
    defaultMapSettingsRestored: 'Standardeinstellungen wiederhergestellt.',
    endpointsTitle: {
      directions: 'Directions',
      isochrones: 'Isochrones',
      geocodeSearch: 'Geocode search',
      autocomplete: 'Geocode autocomplete',
      pois: 'POIs',
      reverseGeocode: 'Geocode reverse'
    },
    apiKey: 'API-Schlüssel',
    customApiKey: 'Benutzerdefinierter API-Schlüssel',
    apiBaseUrl: 'API Basis URL',
    invalidSettingsValue: 'Ungültige Eingaben. Bitte Felder überprüfen oder Standard wiederherstellen.',
    restoreDefaults: 'Zurücksetzen',
    advanced: 'Erweitert',
    mapSettingsSaved: 'Einstellungen gespeichert',
    alwaysFitBounds: 'Immer auf Größe der Route zoomen',
    routeExtraInfo: 'Extra-Informationen',
    mapViewOptions: 'Kartenansicht',
    advancedSettingsWarning: 'Nachfolgende Einstellungen bitte nur ändern, wenn Sie sich sicher sind.',
    customOverlayerTileProviderUrl: 'Benutzerdefinierte Overlayer-Anbieter-URL',
    customTileProviderUrl: 'Spezielle Kartenkachel-Provider-URL',
    defaultTilesProvider: 'Standard Kartenkachel-Provider',
    customTileProviderUrlHint: 'https://domain.tld/pfad/{z}/{x}/{y}.ext?optionalerSchlüssel=Wert',
    prioritizeSearchingForNearbyPlaces: 'Ortssuche priorisiert nahe Orte',
    defaultProfile: 'Standard-Profil',
    compressDataUrlSegment: 'URL-Abschnitt hinter /data/ komprimieren',
    autoFitHighlightedBounds: 'Auto-Zoom zu gewähltem Wegabschnitt',
    reloadToApplyLanguageChangeTitle: 'Die Seite muss neu geladen werden.',
    reloadToApplyLanguageChangeText: 'Um die Sprache vollständig umzustellen, muss die Seite neu geladen werden. Jetzt neu laden?',
    resetShownOnceTooltips: 'Hinweise erneut anzeigen',
    convertStopAfterRouteEndingToDestination: 'Am Ende der Route hinzugefügte Wegpunkte automatisch zum Endpunkt der Route machen',
    skipAllSegments: 'Luftlinien-Route für alle Abschnitte',
    useStopOptimization: 'Route optimieren, wenn ein Wegpunkt via Drag-and-Drop erstellt wird.'
  }
}
